import React from 'react';

export default function ProgressBar({ label, value }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 13, display: "flex", justifyContent: "space-between", marginBottom: 3, color: '#eee' }}>
        <span>{label}</span>
        <span style={{ fontWeight: 'bold' }}>{value}</span>
      </div>
      <div style={{ height: 10, background: "#333", borderRadius: 5, overflow: "hidden" }}>
        <div
          style={{
            height: "100%",
            transition: "width 0.3s ease, background 0.3s ease",
            width: `${value}%`,
            background: value < 30 ? "#f44336" : value > 80 ? "#2196f3" : "#4caf50"
          }}
        />
      </div>
    </div>
  );
}